/* */ 
(function(Buffer) {
  'use strict';
  var TEXT_REGEXP = /\.(txt|htm|html|md|xml|js|min|map|css|scss|less|svg)$/i;
  module.exports = {
    order: 300,
    allowEmpty: true,
    encoding: 'utf8',
    canParse: function isText(file) {
      return (typeof file.data === 'string' || Buffer.isBuffer(file.data)) && TEXT_REGEXP.test(file.url);
    },
    parse: function parseText(file) {
      if (typeof file.data === 'string') {
        return file.data;
      } else if (Buffer.isBuffer(file.data)) {
        return file.data.toString(this.encoding);
      } else {
        throw new Error('data is not text');
      }
    }
  };
})(require('buffer').Buffer);
